//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { MEDIA_AUTOFILL_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';

function openModal() {
  return createAction({
    type: MEDIA_AUTOFILL_MODAL_ACTIONS.OPEN_MEDIA_AUTOFILL_MODAL,
  });
}

function closeModal() {
  return createAction({
    type: MEDIA_AUTOFILL_MODAL_ACTIONS.CLOSE_MEDIA_AUTOFILL_MODAL,
  });
}

function setReadyToShowMediaAutofillModal(readyToShow: boolean) {
  return createAction({
    type: MEDIA_AUTOFILL_MODAL_ACTIONS.SET_READY_TO_SHOW_MEDIA_AUTOFILL_MODAL,
    readyToShow,
  });
}

function setModalContent(modalContent: string) {
  return createAction({
    type: MEDIA_AUTOFILL_MODAL_ACTIONS.SET_MODAL_CONTENT,
    modalContent,
  });
}

export type GalleriesMediaAutofillModalActionType = ReturnType<
  | typeof openModal
  | typeof closeModal
  | typeof setReadyToShowMediaAutofillModal
  | typeof setModalContent
>;

export const actions = {
  openModal,
  closeModal,

  setReadyToShowMediaAutofillModal: (
    readyToShow: boolean,
    modalContent?: string,
  ) => (dispatch: ReduxDispatch) => {
    if (readyToShow && modalContent) {
      dispatch(setModalContent(modalContent));
      dispatch(setReadyToShowMediaAutofillModal(true));
    } else if (!readyToShow) {
      dispatch(setModalContent(''));
      dispatch(setReadyToShowMediaAutofillModal(false));
    }
  },
};
